import { Link } from "react-router-dom";
import { generalFaqs } from "@/mocks/site";
import FaqAccordion from "@/components/feature/FaqAccordion";
import SectionHeading from "@/components/feature/SectionHeading";

export default function FaqPreview() {
  const list = generalFaqs.slice(0, 4);

  return (
    <section className="w-full bg-background-50 px-4 py-14 md:px-8 md:py-20 lg:px-12">
      <div className="mx-auto max-w-4xl">
        <SectionHeading
          align="center"
          eyebrow="新手常见疑问"
          title="第一次来，先看这几个问题"
          desc="关于内容怎么来的、结论怎么定的，都在这里说明白。"
        />
        <div className="mt-8">
          <FaqAccordion items={list} />
        </div>
        <div className="mt-6 text-center">
          <Link
            to="/faq"
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            查看全部 {generalFaqs.length} 个问题
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}